var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPalmToken(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.163,
    y1: 510.934,
    x2: 659.677,
    y2: 193.766,
    gradientTransform: "matrix(-1 0 0 1 703.84 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#bfbfbf"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 351.9,
    cy: 352.3,
    r: 331.1,
    style: {
      fill: "none",
      stroke: "url(#SVGID_1_)",
      strokeWidth: 30,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084502333966158413540000013877855283062170262_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.662,
    y1: 505.524,
    x2: 949.571,
    y2: 44.386
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#bfbfbf"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000084502333966158413540000013877855283062170262_)"
    },
    cx: 351.9,
    cy: 352.3,
    r: 331.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092426012444996628850000010812818428960520868_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.496,
    y1: 504.063,
    x2: 646.343,
    y2: 200.636
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#bfbfbf"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092426012444996628850000010812818428960520868_)"
    },
    d: "M351.9 51.2c40.7 0 80.1 8 117.2 23.7 35.9 15.2 68.1 36.9 95.7 64.5 27.7 27.7 49.4 59.9 64.5 95.7C645 272.2 653 311.6 653 352.3s-8 80.1-23.7 117.2c-15.2 35.9-36.9 68.1-64.5 95.7-27.7 27.7-59.9 49.4-95.7 64.5-37.1 15.7-76.5 23.7-117.2 23.7s-80.1-8-117.2-23.7c-35.9-15.2-68.1-36.9-95.7-64.5-27.7-27.7-49.4-59.9-64.5-95.7-15.8-37-23.7-76.5-23.7-117.2s8-80.1 23.7-117.2c15.2-35.9 36.9-68.1 64.5-95.7 27.7-27.7 59.9-49.4 95.7-64.5 37.1-15.7 76.6-23.7 117.2-23.7m0-30C169 21.2 20.8 169.5 20.8 352.3S169 683.5 351.9 683.5 683 535.2 683 352.4 534.8 21.2 351.9 21.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073704466238199468790000002430235525899401127_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.952,
    y1: 277.579,
    x2: 452.726,
    y2: 277.579
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1a1b20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    style: {
      stopColor: "#1a1b20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#25282e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    style: {
      stopColor: "#31343c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#31343c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073704466238199468790000002430235525899401127_)"
    },
    d: "M221.4 256.7c13.6-12.2 27.3-24.8 41.3-37.1 27.3-24.5 54.5-49.3 82.2-74.1.7-.3 1-.7 1.4-1 .7-.7 1-1 1.7-1.4l.3-.3.3.3c.7.3 1 .7 1.4 1.4.3.3.7 1 1.4 1.4 4.9 5.2 9.8 10.8 14.7 16.1 13.6 15 27.6 30.1 39.9 45.5 16.8 21 31.5 42 39.5 63.6 8 21.7 10.1 43.7 2.4 66.1-7.7 22.7-25.2 46.5-56.6 71-5.6 4.2-13.6 5.2-21 3.8-7.3-1.7-14-5.9-17.1-12.2-3.5-6.6-4.5-11.9-4.2-16.8.3-4.5 2.4-8.7 5.2-12.6 2.8-3.5 5.9-7 9.8-10.8l1-1c3.8-4.2 8-8.4 11.5-13.6 33.2-53.5-36.7-121-93-72-2.4 2.1-4.9 4.5-7.7 7-2.8 2.4-5.2 5.2-8.4 7.7-5.9 5.2-11.9 10.1-17.8 13.3-5.9 3.1-11.9 4.5-17.5 3.1s-11.2-5.2-16.8-14.3c-6.2-9.4-3.7-24.4 6.1-33.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043451541936616969220000017601854754133207196_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.948,
    y1: 424.939,
    x2: 488.048,
    y2: 424.939
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1a1b20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    style: {
      stopColor: "#1a1b20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#25282e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    style: {
      stopColor: "#31343c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#31343c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000142871541931422170200000009731429267920490430_",
    style: {
      fill: "url(#SVGID_00000043451541936616969220000017601854754133207196_)"
    },
    d: "M478 447.2c10.1-9.1 13.3-25.2 6.3-36-22.7-36.4-52.1-.3-71.3 16.8-54.5 47.6-122-17.5-89.9-69.2 13.3-19.6 38.1-29.4 23.4-57-7.3-14-28.7-18.2-41.3-9.1-126.6 98.6-32.9 184.6 39.5 265.4 4.9 5.2 3.8 5.2 9.8.3 41.7-37.4 82.2-74.1 123.5-111.2z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalmToken);
export default __webpack_public_path__ + "static/media/PalmToken.a0e604f59c7299d4f760df5815e1f9ba.svg";
export { ForwardRef as ReactComponent };